import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-survey-update',
  templateUrl: './survey-update.component.html',
  styleUrls: ['./survey-update.component.sass']
})
export class SurveyUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
